import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWattpadComponent } from './simple-icons-wattpad.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWattpadComponent ],
    exports:      [ SimpleIconsWattpadComponent ],
    bootstrap:    []
})
export class SimpleIconsWattpadModule {}
